export default [
  {
    path: '/usedCar-evaluate',
    name: 'usedCar.evaluate',
    component: () => import('@/views/usedCar/evaluate/Index.vue'),
    meta: {
      title: '二手车估价',
      auth: 0,
      backgroundClass: 'bg-black',
    },
  },
  {
    path: '/usedCar-create',
    name: 'usedCar.create',
    component: () => import('@/views/usedCar/evaluate/Create.vue'),
    meta: {
      title: '填写估价信息',
      auth: 0,
      backgroundClass: 'bg-black',
    },
  },
  {
    path: '/usedCar-detail-:id',
    name: 'usedCar.detail',
    component: () => import('@/views/usedCar/evaluate/Detail.vue'),
    meta: {
      title: '估价详情',
      auth: 0,
      backgroundClass: 'bg-black',
    },
  },
];
